export const SLIDE_TO_SHOW = {
	WEB: 3,
	MOBILE: 2,
	TABLET: 2
};
